/**
 * Thin MCP client surface used by the rest of the app. Wraps the
 * Streamable HTTP transport with the two RPCs the chat needs
 * (`tools/list`, `tools/call`) and the obligatory `initialize`
 * handshake.
 */

import { StreamableHttpTransport, MCP_PROTOCOL_VERSION } from "./transport.js";

const CLIENT_INFO = { name: "origin", version: "0.1.0" };

export async function initializeMcp({ baseUrl, getToken, onUnauthorized }) {
  const transport = new StreamableHttpTransport({ baseUrl, getToken, onUnauthorized });
  const result = await transport.request("initialize", {
    protocolVersion: MCP_PROTOCOL_VERSION,
    capabilities: { tools: {} },
    clientInfo: CLIENT_INFO,
  });
  // The "initialized" notification is required by spec before the
  // server will accept any other requests. Fire-and-forget; if it
  // fails the next call will surface the error anyway.
  await transport.notify("notifications/initialized").catch(() => {});
  return {
    transport,
    serverInfo: result?.serverInfo ?? null,
    capabilities: result?.capabilities ?? {},
  };
}

export async function listMcpTools(transport) {
  const result = await transport.request("tools/list");
  return Array.isArray(result?.tools) ? result.tools : [];
}

export async function callMcpTool(transport, name, args, opts = {}) {
  return transport.request(
    "tools/call",
    { name, arguments: args ?? {} },
    { signal: opts.signal },
  );
}
